<template>
  <div id="controller" class="maincont">

    <div class="ef--inner">
      <div class="header-info">
        <div class="unit-info">
          <div class="unit-info-label">ユニットID</div>
          <div class="unit-info-value">
            <span class="controller-select-box">
              <select id="selected_unit_id" v-model="selectedUnitInfo">
                <option v-for="(item, index) in UnitInfo" v-bind:key="index">
                  {{ item }}
                </option>
              </select>
            </span>
          </div>
        </div>

        <div class="menu-info">
          <button id="control-btn" class="controller-bt" @click="onClickRun()" disabled>実 行</button>
        </div>
      </div>
    </div>

    <div class="ef--inner">
      <h2>制御</h2>
      <div class="controller-list-container">
        <table _fixedhead="rows:1;cols:0;" id="controller-table" class="tfTable">

          <thead>
            <tr>
              <th>No.</th>
              <th cmanFilterBtn>データコード</th>
              <th>現在値</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in nInnBeppuControlInfo.dataInfo" v-bind:key="index">
              <td>{{ index + 1 }}</td>
              <td :id="'bynale_code_' + index">{{ item.dataCode }}</td>
              <td>
                <span class="controller-select-box">
                  <select v-model="item.value" @change="onChangeStatus(index)">
                    <option v-for="(item, index) in ValueInfo" v-bind:key="index">
                      {{ item }}
                    </option>
                  </select>
                </span>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Controller",

  components: {
  },

  data: function () {
    return {
      selectedUnitInfo: 3,
      nInnBeppuControlInfo: [],
      UnitInfo: [ 3, 2 ],
      ValueInfo: [ 0, 1 ],
    };
  },

  watch: {
    selectedUnitInfo: async function (newVal) {
      await this.getNInnBeppuControl();
    }
  },

  mounted: function () {
    this.getNInnBeppuControl();
  },

  methods: {
    /* 制御情報取得API */
    getNInnBeppuControl: async function() {
      this.$axios
        .get(`/srv/api/n_inn_beppu_control/?unit_id=${this.selectedUnitInfo}`, {
          withCredentials: true
        })
        .then(response => {
          this.nInnBeppuControlInfo = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },

    /* 状態変更 */
    onChangeStatus: function(index) {
      if (this.nInnBeppuControlInfo.dataInfo[index].value == 1) {
        for (let i = 0; i < this.nInnBeppuControlInfo.dataInfo.length; i++) {
          if (i != index) {
            this.nInnBeppuControlInfo.dataInfo[i].value = 0;
          }
        }
      }

      let btnDisabled = true;
      for (let i = 0; i < this.nInnBeppuControlInfo.dataInfo.length; i++) {
        if (this.nInnBeppuControlInfo.dataInfo[i].value != 0) {
          btnDisabled = false;
          break;
        }
      }

      let btn = document.getElementById("control-btn");
      btn.disabled = btnDisabled;
    },

    /* 実行ボタン */
    onClickRun: function() {
      if (confirm('実行します。よろしいですか？')) {
        this.$axios
          .post(`/srv/api/n_inn_beppu_control/${this.$store.state.loginID}`, this.nInnBeppuControlInfo, {
            withCredentials: true
          })
          .then(response => {
            if (response.data.status === "success") {
              //this.getNInnBeppuControl();
            } else {
              this.reload();
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    },

    /* ページリロード処理 */
    reload() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
  }
};
</script>

<style scoped>
#controller h2 {
  padding-left: 15px;
  background-color: #5ca1d6;
  color: #fff;
  font-size: 18px;
  height: 45px;
  line-height: 45px;
  border-radius: 4px 4px 0 0;
}

#controller table {
  width: 1202px;
}

#controller thead tr {
  width: 100%;
  background-color: #bcd8ee;
  text-align: center;
  font-size: 13px;
  line-height: 25px;
}

#controller thead th {
  padding: 6px 0;
}

#controller thead th:not(:last-child) {
  border-right: 1px solid #7c8d9d;
}

#controller tbody tr {
  width: 100%;
  background-color: #fff;
  text-align: center;
  line-height: 20px;
}

#controller tbody td {
  padding: 3px 0px;
}

#controller tbody td:not(:last-child) {
  border-right: 1px solid #bdc7d0;
}

.maincont {
  padding-top: 60px;
}

.header-info {
  display: flex;
  width: 100%;
}

.menu-info {
  display: flex;
  justify-content: center;
  width: 10%;
  height: 36px;
  margin-top: 7px;
}

.unit-info {
  width: 90%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 10px 20px;
}

.unit-info-label {
  margin-right: 20px;
  font-size: 16px;
}

.unit-info-value {
  font-size: 16px;
}

.controller-select-box {
  position: relative;
  display: inline-block;
}

.controller-select-box select {
  border: 1px solid #5ca1d6;
  /* padding: 5px 34px 5px 20px; */
  padding: 3px 34px 3px 20px;
  font-size: 14px;
  /* font-size: 14px; */
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
}

.controller-select-box select::-ms-expand {
  display: none;
}

.controller-select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  content: '';
  background-color: #9fc8e7;
  pointer-events: none;
  z-index: 99;
}

.controller-select-box::after {
  position: absolute;
  top: -4px;
  bottom: 0;
  right: 6px;
  margin: auto;
  content: "";
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  z-index: 99;
}

.controller-list-container {
  overflow: auto;
  width: auto;
  /* max-height: 150px; */
  max-height: 650px;
  margin-bottom: 20px;
}

.controller-list tr:not(:last-child) {
  border-bottom: 1px solid #bdc7d0;
}

@media screen and (max-width: 1102px) {

  .controller-list-container {
    width: 100%;
  }

}

.controller-bt {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 75px;
  padding: 5px 20px;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.controller-bt:disabled {
  background-color: #91a1af;
}

.controller-bt:disabled:hover {
  background-color: #91a1af;
}

.controller-bt:hover {
  background-color: #005cc0;
}
</style>